<template>
  <div
    class="bg-static-warning-mid text-static-default-hi rounded-md flex flex-col gap-24 p-16"
  >
    <p>{{ i18n(translations.paragraph1) }}</p>

    <p class="whitespace-pre-line">{{ i18n(translations.paragraph2) }}</p>

    <CancelOrderButton :cart-selection-id>
      {{ i18n(translations.cancelOrder) }}
    </CancelOrderButton>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import CancelOrderButton from '~/scopes/checkout/flows/bouygues-in-store/components/CancelOrderButton/CancelOrderButton.vue'

import translations from './NoReplacementWarning.translations'

const i18n = useI18n()
const tracking = useTracking()

onMounted(() => {
  tracking.trackBlockImpression({ name: 'cart_item_no_alternative' })
})

defineProps<{
  cartSelectionId: string
}>()
</script>
